import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"discount-list"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20.7881 2.75391L21.4062 10.793L10.9746 21.2246L2.48926 12.7393L13.0684 2.16016L20.7881 2.75391ZM16.5449 6.99609C15.7639 6.21516 14.4978 6.21518 13.7168 6.99609C12.9358 7.77712 12.9358 9.04316 13.7168 9.82422C14.4978 10.6053 15.7639 10.6053 16.5449 9.82422C17.3259 9.04316 17.3259 7.77711 16.5449 6.99609Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22 17H20M22 21H16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M10.9746 21.2249L2.48932 12.7396L13.0686 2.1604L20.7882 2.75422L21.4065 10.793L10.9746 21.2249Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M13.7166 6.99613C14.4977 6.21508 15.764 6.21508 16.545 6.99613C17.3261 7.77717 17.3261 9.0435 16.545 9.82455C15.764 10.6056 14.4977 10.6056 13.7166 9.82455C12.9356 9.0435 12.9356 7.77717 13.7166 6.99613Z","strokeWidth":"props.strokeWidth"}}]}]}]};

const DiscountList = Vue.extend<IconProps>({
  name: 'DiscountListIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'discount-list',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DiscountList;
